<template>
  <div :class="{ 'dark-mode': isDark }">
    <v-card :dark="isDark" :class="['border-radius-10', noBox]">
      <v-card-title class="main-gradient" v-if="inDialog">
        <span :dark="isDark" class="font-weight-black title title-form">{{i18n('Adicionar Feriado')}}</span>
        <v-spacer></v-spacer>
        <v-icon class="cursor-type" right @click="$emit('cancel')" v-if="inDialog">close</v-icon>
      </v-card-title>
      <v-card-text :class="noMargin">
        <v-container :class="['grid-list-md', 'pt-0', 'pb-0', noMargin]">
          <v-layout class="column wrap px-3">
            <v-layout class="column wrap">
              <v-flex class="xs6 lg6">
                <v-text-field
                  box
                  v-model="record.name"
                  :dark="isDark"
                  :label="i18n('Motivo')"
                  :errorMessages="errorMessagesFor('day')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex class="xs6 lg6">
              <v-date-picker
                v-model="picker"
                :color="color"
                :locale="locale"
                :show-current="showCurrent"
                :type="type"
              ></v-date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap">
          <v-flex class="xs12 justify-flex-end">
            <v-btn flat class="flex-2 secondary-btn-bg-color font-weight-black" @click="$emit('cancel')">{{i18n('Cancelar')}}</v-btn>
            <v-btn class="flex-2 btn-bg-color text-color-white strong font-weight-black" @click="createHoliday">{{i18n('Registrar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'HolidaysForm',
    props: {
      record: {
        type: Object
      },
      errors: {
        type: Object
      },
      inDialog: {
        type: Boolean,
        default: false
      },
      isDark: {
        type: Boolean,
        default: false
      }
    },
    data(vm) {
      return {
        locale: "pt-br",
        color: "#06233B",
        showCurrent: true,
        enableEvents: false,
        picker: new Date().toISOString().substr(0, 10),
        type: 'date',
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      errorMessagesFor(field) {
        if (this.errors[field]) {
          return this.errors[field]
        } else {
          return []
        }
      },
      createHoliday(e) {
        this.record.day = this.picker
        this.$emit('createHoliday')
      },
      updateHoliday(e) {
        this.$emit('updateHoliday')
      }
    },
    computed: {
      noBox() {
        return this.inDialog ? '' : 'elevation-0'
      },
      noMargin() {
        return this.inDialog ? '' : 'px-0'
      },
    },
    mounted() {
    },
    metaInfo: {
      title: "Facilita Pay"
    },
  }
</script>

<style scoped>

.dark-mode .secondary-btn-bg-color{
  color: white !important;
}

.secondary-btn-bg-color{
  color: var(--background-color) !important;
}

.flex-2 {
  flex: 2;
}

.justify-flex-end {
  display: flex;
  justify-items: flex-end;
}

.cursor-type{
  cursor: pointer;
}

.title-form{
  color: #44517B !important;
}

.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}

.text-color-white {
  color: white !important;
}

.hidden {
  display: none;
}

.dark-mode .title-form {
  color: white !important;
}

.v-dialog {
  height: 100% !important;
}

.font-color{
  color: #44517B;
}
</style>



// WEBPACK FOOTER //
// src/HolidaysForm.vue